<template>
  <div style="padding: 20px;background-color: #ffffff;">
    <div ref="page" style="margin-top: 12px;">
      <el-table :data="page" stripe :height="tableHeight" size="medium">
        <el-table-column prop="collegeName" label="就读院校"></el-table-column>
        <el-table-column prop="specialtyName" label="就读专业"></el-table-column>
        <el-table-column prop="enrolTime" label="入学时间">
          <template slot-scope="scope">
            {{$moment(scope.row.addTime).format('YYYY-MM-DD HH:mm')}}
          </template>
        </el-table-column>
        <el-table-column prop="certificatePhotoUrl" label="学生证/毕业证">
          <template slot-scope="scope">
            <div>
              <el-image v-if="scope.row.certificatePhotoUrl2" :src="scope.row.certificatePhotoUrl2" :preview-src-list="[scope.row.certificatePhotoUrl2]" style="width: 50px;height: 50px;"></el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="officialPhotoUrl" label="一寸免冠照">
          <template slot-scope="scope">
            <div>
              <el-image v-if="scope.row.officialPhotoUrl2" :src="scope.row.officialPhotoUrl2" :preview-src-list="[scope.row.officialPhotoUrl2]" style="width: 50px;height: 50px;"></el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="identityName" label="身份名称"></el-table-column>
        <el-table-column prop="informationUrl" label="证明材料">
          <template slot-scope="scope">
            <div>
              <el-image v-if="scope.row.informationUrl2" :src="scope.row.informationUrl2" :preview-src-list="[scope.row.informationUrl2]" style="width: 50px;height: 50px;"></el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="save(scope.row)">审核通过</el-button>
            <el-button size="mini" type="text" style="color: #E91212;" @click="cancel(scope.row)">审核不通过</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 20px;">
        <el-pagination class="text-center" background
                       :page-sizes="[20, 50, 100, 200]" layout="total, sizes, prev, pager, next, jumper"
                       :total="page.total" :page-size="page.pageSize" :current-page="page.pageNum"
                       @current-change="getPage({pageNum:$event})" @size-change="getPage({pageNum:1,pageSize:$event})"></el-pagination>
      </div>
    </div>
    <el-dialog title="用户审核" v-if="editForm.show" :visible.sync="editForm.show" width="600px"
               :close-on-press-escape="false" :close-on-click-modal="false" :destroy-on-close="true">
      <Edit :row="editForm.row" @close="getPage()"></Edit>
    </el-dialog>
  </div>
</template>
<script>
import Edit from './management-detail-edit'

export default {
  name: 'management',
  components: { Edit },
  props: [],
  data () {
    return {
      tableHeight: 200,
      queryParam: {},
      page: [],
      editForm: { show: false, row: null }
    }
  },
  async created () {
    await this.getPage()
  },
  async mounted () {
    this.Tool.windowResizeEvent(() => {
      this.tableHeight = this.Tool.calcTableHeight(this.$refs['page'])
    })
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async getPage (queryParam) {
      try {
        this.editForm.show = false
        // this.queryParam = Object.assign({}, this.queryParam, queryParam)
        let page = await this.$HTTP.ApiAppUser.getPageDetail({
          appUserId: this.$route.query.appUserId,
          authStatus: 1
        })
        for (let i in page) {
          let item = page[i]
          if (item.certificatePhotoUrl) {
            item.certificatePhotoUrl2 = await this.$HTTP.ApiOss.signatureUrl(item.certificatePhotoUrl, 'audit-data')
            console.log(item.certificatePhotoUrl2, '2333')
          }
          if (item.officialPhotoUrl) {
            item.officialPhotoUrl2 = await this.$HTTP.ApiOss.signatureUrl(item.officialPhotoUrl, 'audit-data')
          }
          if (item.informationUrl) {
            item.informationUrl2 = await this.$HTTP.ApiOss.signatureUrl(item.informationUrl, 'audit-data')
          }
        }
        this.page = page
        this.$nextTick(() => {
          let wrapper = window.document.getElementsByClassName('el-table__body-wrapper')
          if (wrapper) {
            wrapper[0].scrollTop = 0
          }
        })
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    // async edit (row) {
    //   try {
    //     this.editForm.show = true
    //     if (row) {
    //       this.editForm.row = row
    //     } else {
    //       this.editForm.row = null
    //     }
    //   } catch (e) {
    //     this.Tool.doError(e)
    //   }
    // },
    async save (row) {
      if (row) {
        let param = {
          identityId: row.identityId,
          isPass: 1
        }
        await this.$HTTP.ApiAppUser.auditUser(param)
        this.$message({ type: 'success', message: '操作成功' })
        await this.getPage()
      }
    },
    async cancel (row) {
      if (row) {
        let param = {
          identityId: row.identityId,
          isPass: 0
        }
        await this.$HTTP.ApiAppUser.auditUser(param)
        this.$message({ type: 'success', message: '操作成功' })
        await this.getPage()
      }
    }
  }
}
</script>
